
define('template!editCatTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="category">\n    <div class="cat-side">\n        <div class="cat">\n            <div class="cat-code">' +
((__t = ( code )) == null ? '' : __t) +
'</div>\n            ';
 if (notRelevantFor3d) { ;
__p += '\n            <div class="prd-3d-badge prd-3d-invalid">\n                <i class="mdi-action-3d-rotation"></i><span>X</span>\n            </div>\n            ';
 } ;
__p += '\n            <div class="cat-info">\n                <div class="cat-name">' +
((__t = ( name )) == null ? '' : __t) +
'</div>\n            </div>\n        </div>\n    </div>\n    <div class="options-side">\n        <div class="options">\n            <div class="options-title">\n                Options\n                <i class="mdi mdi-av-my-library-add btn-add-option clickable prd-add-btn-inline"></i>\n            </div>\n            <div class="options-header">\n                <div class="code">Code</div>\n                <div class="name">Name</div>\n                <div class="color">Color</div>\n                <div class="images">Images</div>\n            </div>\n            <div class="options-region"></div>\n        </div>\n    </div>\n    ';
 if (!readOnly) { ;
__p += '\n    <div class="btn-container btn-pa-container" style="display: none;">\n        <i class="mdi mdi-action-delete btn-delete-poc clickable btn-frame"></i>\n        <i class="mdi mdi-editor-mode-edit btn-edit-poc clickable btn-frame"></i>\n    </div>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

